import React, { useContext, useState, useEffect } from 'react'
import i18n from 'live/services/i18n'
import globalNotification from 'live/services/global-notification'
import CodeMirrorWrapper from 'live/components/codemirror/codemirror'
import styled from 'styled-components'
import api from '../api'

require('codemirror/mode/javascript/javascript')

const codeMirrorOptions = {
    mode: 'application/json',
    matchBrackets: true,
    lineNumbers: true,
    foldGutter: true,
}

const RunParametersDefaultConfig = ({ }) => {
    const [code, setCode] = useState("{}")
    const [validationError, setValidationError] = useState("")

    function fetchDefaultParameters() {
        const controller = new AbortController()
        const signal = controller.signal

        api.getDefaultParameters(signal).then(response => {
            if (response.ok) {
                response.json().then((data) => {
                    const parameters = data?.parameters ?? []
                    // Custom parsing the json to be one object per line
                    setCode("[\n" + parameters.map((e, i) => JSON.stringify(e) + (i < parameters.length - 1 ? "," : "")).join("\n") + "\n]")
                })
            }
        })

        return () => controller.abort()
    }

    function onSave() {
        if (validationError)
            return

        api.saveDefaultParameters(JSON.parse(code))
            .then(response => {
                if (response.ok) {
                    globalNotification.success(i18n('Saved successfully.'))
                    window.location.reload()
                } else {
                    globalNotification.error(i18n('Error occurred while saving.'))
                    console.error(response)
                }
            })
    }

    useEffect(() => {
        fetchDefaultParameters()
    }, [])

    useEffect(() => {
        try {
            setValidationError("")
            JSON.parse(code)
        } catch (error) {
            const validationError = error
            console.log('validationError', validationError)
            setValidationError(validationError.toString())
        }
    }, [code])

    return (
        <StyledContainer>
            <div className='container'>
                {/* <textarea value={code} onChange={(e) => setCode(e.target.value)} /> */}
                <CodeMirrorWrapper value={code} onChange={(e) => setCode(e)} options={codeMirrorOptions} />

                {validationError ? (
                    <div className="has-error">
                        <b className="help-block">{validationError}</b>
                    </div>
                ) : ''}
                <Footer>
                    <button
                        className="btn btn-primary"
                        disabled={!!validationError}
                        onClick={onSave}
                    >
                        Save
                    </button>
                </Footer>
            </div>
        </StyledContainer>
    )
}

const Footer = styled.div`
    margin: 10px;
`

const StyledContainer = styled.div`
    @media (min-width: 992px)
    .container {
        width: 970px;
    }

    .container {
        padding: 20px;

        .console-content {
            min-height: 140px;
            height: 100%;
            border: solid 1px lightgray;
        }

        .CodeMirror {
            height: 900px !important;
        }

        .has-error, .help-block {
            color: var(--brand-danger) !important;
        }
    }
`

export default RunParametersDefaultConfig